// import React, { useEffect, useState, useMemo } from "react";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import "./CancelandRefund.css";
// import axios from "axios";

// const Cancelandrefundpage = () => {
//     const [allData, setAllData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const { showLoader, hideLoader } = useLoader();
//     const [filterOrderId, setFilterOrderId] = useState("");
//     const [filterName, setFilterName] = useState("");
//     const [filterDate, setFilterDate] = useState("");
//     const [filterStatus, setFilterStatus] = useState("");

//     const [selectedItem, setSelectedItem] = useState(null); // Details modal

//     const [isPopupOpen, setIsPopupOpen] = useState(false); // Refund popup
//     const [selectedRefund, setSelectedRefund] = useState(null);

//     // Fetch refund history from API
//     const fetchRefundHistory = async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             showLoader();
//             const token = localStorage.getItem("authToken");
//             if (!token) throw new Error("Authentication token not found. Please login again.");

//             const res = await axios.get(
//                 "https://backend.maamaas.com/food/api/refundhistory/all",
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             if (Array.isArray(res.data)) {
//                 // 🔥 Show only Online_Payment AND Maamaas_Wallet rows
//                 const filteredPayments = res.data.filter(
//                     item => item.paymentMethod === "Online_Payment" || item.paymentMethod === "Maamaas_Wallet"
//                 );

//                 setAllData(filteredPayments);
//                 setFilteredData(filteredPayments);
//             } else {
//                 throw new Error("Unexpected response format");
//             }
//         } catch (err) {
//             console.error(err);
//             setError(err?.response?.data?.message || err.message || "Failed to fetch data.");
//         } finally {
//             setLoading(false);
//             hideLoader();
//         }
//     };


//     useEffect(() => {
//         fetchRefundHistory();
//     }, []);

//     // Filters
//     useEffect(() => {
//         let currentData = [...allData];
//         if (filterOrderId)
//             currentData = currentData.filter((item) =>
//                 item.userId.toLowerCase().includes(filterOrderId.toLowerCase())
//             );
//         if (filterName)
//             currentData = currentData.filter((item) =>
//                 item.userName.toLowerCase().includes(filterName.toLowerCase())
//             );
//         if (filterDate)
//             currentData = currentData.filter(
//                 (item) => new Date(item.cancelledAt).toISOString().split("T")[0] === filterDate
//             );
//         if (filterStatus)
//             currentData = currentData.filter((item) => item.status === filterStatus);

//         setFilteredData(currentData);
//     }, [allData, filterOrderId, filterName, filterDate, filterStatus]);

//     const updateItemStatus = (userId, newStatus) => {
//         setAllData((prevData) =>
//             prevData.map((item) => (item.userId === userId ? { ...item, status: newStatus } : item))
//         );
//     };

//     // Approve refund: fetch details and show popup
//     const handleApprove = async (refundId) => {
//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) throw new Error("Authentication token is missing.");

//             const res = await fetch(
//                 `https://backend.maamaas.com/food/api/refundhistory/get/order/${refundId}`,
//                 {
//                     method: "GET",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (!res.ok) throw new Error(`Failed to fetch refund details. Status: ${res.status}`);

//             const data = await res.json();
//             let refundDetails = null;
//             if (data?.refundId) refundDetails = data;
//             else if (Array.isArray(data) && data.length > 0) refundDetails = data[0];
//             else if (data?.data?.refundId) refundDetails = data.data;
//             else throw new Error("Refund details not found in response.");

//             setSelectedRefund(refundDetails);
//             setIsPopupOpen(true);
//         } catch (err) {
//             console.error(err);
//             alert("Could not fetch refund details.");
//         }
//     };

//     const closePopup = () => {
//         setIsPopupOpen(false);
//         setSelectedRefund(null);
//     };

//     const handleSaveRefund = async () => {
//         if (!selectedRefund || !selectedRefund.transactionId || !selectedRefund.price) {
//             alert("Missing transaction ID or amount.");
//             return;
//         }

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication token is missing.");
//             return;
//         }

//         try {
//             // Handle different payment methods
//             if (selectedRefund.paymentMethod === "Online_Payment") {
//                 // 1️⃣ CALL REFUND API FOR ONLINE PAYMENT
//                 const refundResponse = await fetch(
//                     "https://backend.maamaas.com/food/api/payments/refund",
//                     {
//                         method: "POST",
//                         headers: {
//                             "Content-Type": "application/json",
//                             Authorization: `Bearer ${token}`,
//                         },
//                         body: JSON.stringify({
//                             payment_id: selectedRefund.transactionId,
//                         }),
//                     }
//                 );

//                 const refundResult = await refundResponse.json();

//                 if (!refundResponse.ok) {
//                     alert("Refund failed: " + (refundResult?.message || "Unknown error"));
//                     return;
//                 }
//             } else if (selectedRefund.paymentMethod === "Maamaas_Wallet") {
//                 // Handle wallet refund logic here
//                 // You might need a different API endpoint for wallet refunds
//                 alert("Maamaas Wallet refund logic would be implemented here");
//             }

//             // 2️⃣ CALL UPDATE REFUND HISTORY API (same for both payment methods)
//             const updateResponse = await fetch(
//                 `https://backend.maamaas.com/food/api/refundhistory/update/${selectedRefund.refundId}/REFUNDED`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             const updateResult = await updateResponse.json();

//             if (!updateResponse.ok) {
//                 alert("Refund submitted but history update failed: " + (updateResult?.message || "Unknown error"));
//                 return;
//             }

//             alert("✅ Refund processed and history updated successfully!");
//             closePopup();

//         } catch (err) {
//             console.error(err);
//             alert("Something went wrong.");
//         }
//     };




//     const closeDetailsModal = () => setSelectedItem(null);


//     const handleExport = () => {
//         if (filteredData.length === 0) return alert("No data to export.");
//         const headers = [
//             "Order ID",
//             "Name",
//             "Request Date",
//             "Resolution Date",
//             "Request Time",
//             "Amount",
//             "Transaction ID",
//             "Payment Method",
//             "Reason",
//             "Status",
//         ];
//         const csvRows = [
//             headers.join(","),
//             ...filteredData.map((row) =>
//                 [
//                     `"${row.userId}"`,
//                     `"${row.orderId}"`,
//                     `"${row.userName}"`,
//                     `"${new Date(row.cancelledAt).toLocaleDateString()}"`,
//                     `"${row.resolutionDate || ""}"`,
//                     `"${new Date(row.cancelledAt).toLocaleTimeString()}"`,
//                     `"${row.price?.toFixed(2) || 0}"`,
//                     `"${row.transactionId}"`,
//                     `"${row.paymentMethod}"`,
//                     `"${row.reason?.replace(/\n/g, " ") || ""}"`,
//                     `"${row.status}"`,
//                 ].join(",")
//             ),
//         ];
//         const csvString = csvRows.join("\n");
//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const link = document.createElement("a");
//         const url = URL.createObjectURL(blob);
//         link.setAttribute("href", url);
//         link.setAttribute("download", "cancellations_and_refunds.csv");
//         link.style.visibility = "hidden";
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     const uniqueOrderIds = useMemo(
//         () => [...new Set(allData.map((item) => item.userId))].sort(),
//         [allData]
//     );
//     const uniqueNames = useMemo(
//         () => [...new Set(allData.map((item) => item.userName))].sort(),
//         [allData]
//     );
//     const uniqueStatuses = useMemo(
//         () => [...new Set(allData.map((item) => item.status))].sort(),
//         [allData]
//     );

//     const getStatusBadgeClass = (status) => {
//         switch (status.toLowerCase()) {
//             case "pending":
//                 return "bg-warning text-dark";
//             case "approved":
//                 return "bg-success";
//             case "rejected":
//                 return "bg-danger";
//             default:
//                 return "bg-secondary";
//         }
//     };

//     const thStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         fontWeight: "bold",
//         backgroundColor: "rgb(230 109 51)",
//         color: "white",
//     };
//     const tdStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//     };
//     const inputStyle = {
//         width: "100%",
//         padding: "8px",
//         borderRadius: "6px",
//         border: "1px solid #ccc",
//         marginTop: "4px",
//         backgroundColor: "#f9f9f9",
//         fontSize: "15px",
//     };
//     const filterSelectStyle = {
//         backgroundColor: "rgb(230 109 51)",
//         color: "#fff",
//         border: "none",
//         height: "35px",
//         borderRadius: "4px"
//     };

//     return (
//         <div className="container-fluid d-flex flex-column">
//             {/* Filters & Export */}
//             <div className="row flex-grow-1" style={{ marginTop: "-10px" }}>
//                 <div className="col-lg-12 col-12 ps-2 pe-2">
//                     <div className="vh-100" style={{ scrollbarWidth: "none", }}>
//                         {/* all the necessary foramted code also */}
//                         <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">

//                             <div className="d-flex flex-wrap align-items-center gap-2">
//                                 <div style={{ minWidth: "120px" }}>
//                                     <input
//                                         className="form-control form-control-sm"
//                                         type="date"
//                                         style={filterSelectStyle}
//                                         value={filterDate}
//                                         onChange={(e) => setFilterDate(e.target.value)}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Right section: Export button */}
//                             <button
//                                 onClick={handleExport}
//                                 className="btn btn-sm mt-2 mt-md-0"
//                                 style={{
//                                     width: "120px",
//                                     backgroundColor: "rgb(230 109 51)",
//                                     color: "#fff",
//                                     fontWeight: "bold",
//                                 }}
//                             >
//                                 Export CSV
//                             </button>
//                         </div>


//                         {/* Table */}
//                         {loading && <p className="text-center mt-5">Loading data...</p>}
//                         {error && <p className="text-center text-danger mt-5">{error}</p>}
//                         {!loading && !error && (
//                             <div
//                                 className="table-responsive shadow-sm roror3"
//                                 style={{ height: "calc(100vh - 255px)", overflowY: "auto", scrollbarWidth: "none", marginTop: "10px" }}
//                             >
//                                 <table className="table-striped table-bordered table-hover align-middle">
//                                     <thead style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}>
//                                         <tr>
//                                             <th className="p-2 text-center">SNO</th>
//                                             <th className="p-2 text-center">Order ID</th>
//                                             <th className="p-2 text-center">User ID</th>
//                                             <th className="p-2 text-center">Transaction Id</th>
//                                             <th className="p-2 text-center">Name</th>
//                                             <th className="p-2 text-center">Request Date</th>
//                                             <th className="p-2 text-center">Request Time</th>
//                                             <th className="p-2 text-center">Amount</th>
//                                             <th className="p-2 text-center">Refund ID</th>
//                                             <th className="p-2 text-center">Payment</th>
//                                             <th className="p-2 text-center">Description</th>
//                                             <th className="p-2 text-center">Status</th>
//                                             <th className="text-center p-2">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredData.map((item, index) => (
//                                             <tr key={item.refundId}>
//                                                 <td style={tdStyle}>{index + 1}</td>
//                                                 <td style={tdStyle}>{item.orderId}</td>
//                                                 <td style={tdStyle}>{item.userId}</td>
//                                                 <td style={tdStyle}>{item.transactionId}</td>
//                                                 <td style={tdStyle}>{item.userName}</td>
//                                                 <td style={tdStyle}>
//                                                     {new Date(item.cancelledAt).toLocaleDateString()}
//                                                 </td>
//                                                 <td style={tdStyle}>
//                                                     {new Date(item.cancelledAt).toLocaleTimeString()}
//                                                 </td>
//                                                 <td style={tdStyle}>₹{Number(item.price || 0).toFixed(2)}</td>
//                                                 <td style={tdStyle}>{item.refundId}</td>
//                                                 <td style={tdStyle}>{item.paymentMethod}</td>
//                                                 <td style={tdStyle}>Refund Requested</td>
//                                                 <td style={tdStyle}>{item.status}</td>
//                                                 <td className="p-3">
//                                                     <div className="d-flex flex-column gap-2">
//                                                         <button
//                                                             className="btn btn-success btn-sm"
//                                                             onClick={() => handleApprove(item.refundId)}
//                                                             disabled={item.refundStatus === "REFUNDED"}
//                                                         >
//                                                             {item.refundStatus === "REFUNDED" ? "Refunded" : "Approve"}
//                                                         </button>

//                                                     </div>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Details Modal */}
//             {selectedItem && (
//                 <div className="modal fade show bg-white" tabIndex={-1} style={{ display: "block" }}>
//                     <div className="modal-dialog modal-lg bg-white">
//                         <div className="modal-content bg-white border-0">
//                             <div className="modal-header">
//                                 <h5 className="modal-title">Cancellation/Refund Details</h5>
//                                 <button type="button" className="btn-close" onClick={closeDetailsModal}></button>
//                             </div>
//                             <div className="modal-body">
//                                 <p><strong>Order ID:</strong> {selectedItem.userId}</p>
//                                 <p><strong>Customer Name:</strong> {selectedItem.userName}</p>
//                                 <p><strong>Request Date:</strong> {selectedItem.requestDate}</p>
//                                 <p><strong>Request Time:</strong> {selectedItem.requestTime}</p>
//                                 <p><strong>Amount:</strong> ${selectedItem.amount?.toFixed(2)}</p>
//                                 <p><strong>Transaction ID:</strong> {selectedItem.transactionId}</p>
//                                 <p><strong>Payment Method:</strong> {selectedItem.paymentMethod}</p>
//                                 <p><strong>Proposed Resolution Date:</strong> {selectedItem.resolutionDate}</p>
//                                 <p className="mb-1"><strong>Reason for Cancellation/Refund:</strong></p>
//                                 <p className="p-2 bg-light border rounded" style={{ whiteSpace: "pre-line" }}>
//                                     {selectedItem.reason}
//                                 </p>
//                                 <p><strong>Current Status:</strong>
//                                     <span className={`ms-2 badge ${getStatusBadgeClass(selectedItem.status)}`}>
//                                         {selectedItem.status}
//                                     </span>
//                                 </p>
//                             </div>
//                             <div className="modal-footer">
//                                 <button className="btn btn-primary" onClick={closeDetailsModal}>Close</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Refund Popup */}
//             {isPopupOpen && selectedRefund && (
//                 <div style={{
//                     position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
//                     background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px"
//                 }}>
//                     <div style={{
//                         background: "#fff", padding: "30px", borderRadius: "12px", width: "100%", maxWidth: "500px",
//                         boxShadow: "0 8px 20px rgba(0,0,0,0.25)", fontFamily: "'Segoe UI', sans-serif"
//                     }}>
//                         <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
//                             <label>Refund ID:<input type="text" value={selectedRefund.refundId || ""} readOnly style={inputStyle} /></label>
//                             <label>Order ID:<input type="text" value={selectedRefund.orderId || ""} readOnly style={inputStyle} /></label>
//                             <label>User Name:<input type="text" value={selectedRefund.userName || ""} readOnly style={inputStyle} /></label>
//                             <label>Price:<input type="text" value={`₹${selectedRefund.price || "0.00"}`} readOnly style={inputStyle} /></label>
//                             <label>Cancelled At:<input type="text" value={selectedRefund.cancelledAt ? new Date(selectedRefund.cancelledAt).toLocaleString() : ""} readOnly style={inputStyle} /></label>
//                             <label>Transaction ID:<input type="text" value={selectedRefund.transactionId || ""} readOnly style={inputStyle} /></label>
//                             <label>Payment Method:<input type="text" value={selectedRefund.paymentMethod || ""} readOnly style={inputStyle} /></label>
//                         </div>
//                         <div style={{ textAlign: "center", marginTop: "25px" }}>
//                             <button onClick={closePopup} style={{ backgroundColor: "#d63031", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" }}>Close</button>
//                             <button onClick={handleSaveRefund} style={{ backgroundColor: "#00b894", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold", marginLeft: "10px" }}>Save</button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Cancelandrefundpage;










// import React, { useEffect, useState, useMemo } from "react";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import axios from "axios";

// const Cancelandrefundpage = () => {
//     const [allData, setAllData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const { showLoader, hideLoader } = useLoader();

//     // New filter states
//     const [searchType, setSearchType] = useState("userId"); // Default search type
//     const [searchQuery, setSearchQuery] = useState("");
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [filterDate, setFilterDate] = useState("");

//     // Search options for dropdown
//     const searchOptions = [
//         { value: "userId", label: "User ID" },
//         { value: "orderId", label: "Order ID" },
//         { value: "userName", label: "User Name" },
//         { value: "transactionId", label: "Transaction ID" },
//         { value: "refundId", label: "Refund ID" }
//     ];

//     const [selectedItem, setSelectedItem] = useState(null); // Details modal
//     const [isPopupOpen, setIsPopupOpen] = useState(false); // Refund popup
//     const [selectedRefund, setSelectedRefund] = useState(null);

//     // Fetch refund history from API
//     const fetchRefundHistory = async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             showLoader();
//             const token = localStorage.getItem("authToken");
//             if (!token) throw new Error("Authentication token not found. Please login again.");

//             const res = await axios.get(
//                 "https://backend.maamaas.com/food/api/refundhistory/all",
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             if (Array.isArray(res.data)) {
//                 // 🔥 Show only Online_Payment AND Maamaas_Wallet rows
//                 const filteredPayments = res.data.filter(
//                     item => item.paymentMethod === "Online_Payment" || item.paymentMethod === "Maamaas_Wallet"
//                 );

//                 // Add serial numbers
//                 const dataWithSno = filteredPayments.map((item, index) => ({
//                     ...item,
//                     sno: index + 1
//                 }));

//                 setAllData(dataWithSno);
//                 setFilteredData(dataWithSno);
//             } else {
//                 throw new Error("Unexpected response format");
//             }
//         } catch (err) {
//             console.error(err);
//             setError(err?.response?.data?.message || err.message || "Failed to fetch data.");
//         } finally {
//             setLoading(false);
//             hideLoader();
//         }
//     };

//     useEffect(() => {
//         fetchRefundHistory();
//     }, []);

//     // Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "userId": return "Search User ID";
//             case "orderId": return "Search Order ID";
//             case "userName": return "Search User Name";
//             case "transactionId": return "Search Transaction ID";
//             case "refundId": return "Search Refund ID";
//             default: return "Search...";
//         }
//     };

//     // Filter data based on selected search type, query, status, and date
//     const searchFilteredData = useMemo(() => {
//         if (!searchQuery.trim() && !selectedStatusFilter && !filterDate) {
//             return allData;
//         }

//         const query = searchQuery.toLowerCase().trim();

//         return allData.filter(item => {
//             // Search filter
//             let searchMatch = true;
//             if (searchQuery.trim()) {
//                 const fieldValue = item[searchType];
//                 searchMatch = fieldValue && 
//                     fieldValue.toString().toLowerCase().includes(query);
//             }

//             // Status filter
//             let statusMatch = true;
//             if (selectedStatusFilter) {
//                 statusMatch = item.status === selectedStatusFilter;
//             }

//             // Date filter
//             let dateMatch = true;
//             if (filterDate) {
//                 const itemDate = item.cancelledAt ? 
//                     new Date(item.cancelledAt).toISOString().split("T")[0] : "";
//                 dateMatch = itemDate === filterDate;
//             }

//             return searchMatch && statusMatch && dateMatch;
//         });
//     }, [allData, searchType, searchQuery, selectedStatusFilter, filterDate]);

//     // Update filteredData whenever searchFilteredData changes
//     useEffect(() => {
//         setFilteredData(searchFilteredData);
//     }, [searchFilteredData]);

//     // Clear all filters
//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setSelectedStatusFilter("");
//         setFilterDate("");
//     };

//     const updateItemStatus = (userId, newStatus) => {
//         setAllData((prevData) =>
//             prevData.map((item) => (item.userId === userId ? { ...item, status: newStatus } : item))
//         );
//     };

//     // Approve refund: fetch details and show popup
//     const handleApprove = async (refundId) => {
//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) throw new Error("Authentication token is missing.");

//             const res = await fetch(
//                 `https://backend.maamaas.com/food/api/refundhistory/get/order/${refundId}`,
//                 {
//                     method: "GET",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (!res.ok) throw new Error(`Failed to fetch refund details. Status: ${res.status}`);

//             const data = await res.json();
//             let refundDetails = null;
//             if (data?.refundId) refundDetails = data;
//             else if (Array.isArray(data) && data.length > 0) refundDetails = data[0];
//             else if (data?.data?.refundId) refundDetails = data.data;
//             else throw new Error("Refund details not found in response.");

//             setSelectedRefund(refundDetails);
//             setIsPopupOpen(true);
//         } catch (err) {
//             console.error(err);
//             alert("Could not fetch refund details.");
//         }
//     };

//     const closePopup = () => {
//         setIsPopupOpen(false);
//         setSelectedRefund(null);
//     };

//     const handleSaveRefund = async () => {
//         if (!selectedRefund || !selectedRefund.transactionId || !selectedRefund.price) {
//             alert("Missing transaction ID or amount.");
//             return;
//         }

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication token is missing.");
//             return;
//         }

//         try {
//             // Handle different payment methods
//             if (selectedRefund.paymentMethod === "Online_Payment") {
//                 // 1️⃣ CALL REFUND API FOR ONLINE PAYMENT
//                 const refundResponse = await fetch(
//                     "https://backend.maamaas.com/food/api/payments/refund",
//                     {
//                         method: "POST",
//                         headers: {
//                             "Content-Type": "application/json",
//                             Authorization: `Bearer ${token}`,
//                         },
//                         body: JSON.stringify({
//                             payment_id: selectedRefund.transactionId,
//                         }),
//                     }
//                 );

//                 const refundResult = await refundResponse.json();

//                 if (!refundResponse.ok) {
//                     alert("Refund failed: " + (refundResult?.message || "Unknown error"));
//                     return;
//                 }
//             } else if (selectedRefund.paymentMethod === "Maamaas_Wallet") {
//                 // Handle wallet refund logic here
//                 // You might need a different API endpoint for wallet refunds
//                 alert("Maamaas Wallet refund logic would be implemented here");
//             }

//             // 2️⃣ CALL UPDATE REFUND HISTORY API (same for both payment methods)
//             const updateResponse = await fetch(
//                 `https://backend.maamaas.com/food/api/refundhistory/update/${selectedRefund.refundId}/REFUNDED`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             const updateResult = await updateResponse.json();

//             if (!updateResponse.ok) {
//                 alert("Refund submitted but history update failed: " + (updateResult?.message || "Unknown error"));
//                 return;
//             }

//             alert("✅ Refund processed and history updated successfully!");
//             closePopup();

//         } catch (err) {
//             console.error(err);
//             alert("Something went wrong.");
//         }
//     };

//     const closeDetailsModal = () => setSelectedItem(null);

//     // Fixed export function to export filtered data
//     const handleExport = () => {
//         const exportData = filteredData.length > 0 ? filteredData : allData;

//         if (exportData.length === 0) {
//             alert("There is no data to export.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = [
//             "S.NO",
//             "Order ID",
//             "User ID",
//             "Name",
//             "Request Date",
//             "Request Time",
//             "Amount",
//             "Transaction ID",
//             "Refund ID",
//             "Payment Method",
//             "Status",
//             "Cancelled At"
//         ];

//         const csvRows = exportData.map((row) => [
//             row.sno || '',
//             row.orderId || '',
//             row.userId || '',
//             row.userName || '',
//             row.cancelledAt ? new Date(row.cancelledAt).toLocaleDateString() : '',
//             row.cancelledAt ? new Date(row.cancelledAt).toLocaleTimeString() : '',
//             `₹${Number(row.price || 0).toFixed(2)}`,
//             row.transactionId || '',
//             row.refundId || '',
//             row.paymentMethod || '',
//             row.status || '',
//             row.cancelledAt || ''
//         ]);

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", "cancellations_and_refunds.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     const uniqueStatuses = useMemo(
//         () => [...new Set(allData.map((item) => item.status))].sort(),
//         [allData]
//     );

//     const getStatusBadgeClass = (status) => {
//         switch (status.toLowerCase()) {
//             case "pending":
//                 return "bg-warning text-dark";
//             case "approved":
//                 return "bg-success";
//             case "rejected":
//                 return "bg-danger";
//             default:
//                 return "bg-secondary";
//         }
//     };

//     const thStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         fontWeight: "bold",
//         backgroundColor: "rgb(230 109 51)",
//         color: "white",
//     };
//     const tdStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//     };
//     const inputStyle = {
//         width: "100%",
//         padding: "8px",
//         borderRadius: "6px",
//         border: "1px solid #ccc",
//         marginTop: "4px",
//         backgroundColor: "#f9f9f9",
//         fontSize: "15px",
//     };

//     return (
//         <div className="container-fluid d-flex flex-column">
//             {/* Filters & Export */}
//             <div className="row flex-grow-1" style={{ marginTop: "0px" }}>
//                 <div className="col-lg-12 col-12 ps-2 pe-2">
//                     <div className="vh-100" style={{ scrollbarWidth: "none", }}>
//                         {/* Filter Controls - Same as Userdetails */}
//                         <div className="row g-2 mb-1 align-items-center me-0">
//                             {/* Search Type Dropdown and Search Input - Side by Side */}
//                             <div className="col-md-auto col-12">
//                                 <div className="d-flex align-items-center" style={{ gap: '10px' }}>
//                                     {/* Search Type Dropdown */}
//                                     <div style={{ minWidth: '150px' }}>
//                                         <select
//                                             className="form-select"
//                                             value={searchType}
//                                             onChange={(e) => setSearchType(e.target.value)}
//                                             style={{ height: "40px" }}
//                                         >
//                                             {searchOptions.map(option => (
//                                                 <option key={option.value} value={option.value}>
//                                                     {option.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     {/* Search Input */}
//                                     <div style={{ minWidth: '200px' }}>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             placeholder={getPlaceholderText()}
//                                             value={searchQuery}
//                                             onChange={(e) => setSearchQuery(e.target.value)}
//                                             style={{ height: "40px" }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Status Filter */}
//                             <div className="col-md-auto col-12">
//                                 <select
//                                     className="form-select"
//                                     value={selectedStatusFilter}
//                                     onChange={(e) => setSelectedStatusFilter(e.target.value)}
//                                     aria-label="Filter by status"
//                                     style={{ maxWidth: '150px', height: "40px" }}
//                                 >
//                                     <option value="">All Status</option>
//                                     {uniqueStatuses.map(status => (
//                                         <option key={status} value={status}>{status}</option>
//                                     ))}
//                                 </select>
//                             </div>

//                             {/* Date Filter */}
//                             <div className="col-md-auto col-12">
//                                 <input
//                                     className="form-control"
//                                     type="date"
//                                     value={filterDate}
//                                     onChange={(e) => setFilterDate(e.target.value)}
//                                     style={{ height: "40px", minWidth: '150px' }}
//                                 />
//                             </div>

//                             {/* Clear Filters Button */}
//                             <div className="col-md-auto col-12">
//                                 <button
//                                     className="btn"
//                                     onClick={clearAllFilters}
//                                     style={{
//                                         backgroundColor: '#6c757d',
//                                         color: '#fff',
//                                         height: "40px",
//                                         padding: "0 15px"
//                                     }}
//                                 >
//                                     Clear Filters
//                                 </button>
//                             </div>

//                             {/* Export Button */}
//                             <div className="col-md col-12">
//                                 <div className="d-flex justify-content-start justify-content-md-end">
//                                     <button
//                                         onClick={handleExport}
//                                         className="btn"
//                                         style={{ 
//                                             backgroundColor: 'rgb(230 109 51)', 
//                                             color: '#fff',
//                                             height: "40px",
//                                             padding: "0 20px",
//                                             fontWeight: "bold",
//                                         }}
//                                     >
//                                         Export CSV
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Table */}
//                         {loading && <p className="text-center mt-5">Loading data...</p>}
//                         {error && <p className="text-center text-danger mt-5">{error}</p>}
//                         {!loading && !error && (
//                             <div
//                                 className="table-responsive shadow-sm roror3"
//                                 style={{ height: "calc(100vh - 255px)", overflowY: "auto", scrollbarWidth: "none", marginTop: "10px" }}
//                             >
//                                 <table className="table-striped table-bordered table-hover align-middle">
//                                     <thead style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}>
//                                         <tr>
//                                             <th className="p-2 text-center">SNO</th>
//                                             <th className="p-2 text-center">Order ID</th>
//                                             <th className="p-2 text-center">User ID</th>
//                                             <th className="p-2 text-center">Transaction Id</th>
//                                             <th className="p-2 text-center">Name</th>
//                                             <th className="p-2 text-center">Request Date</th>
//                                             <th className="p-2 text-center">Request Time</th>
//                                             <th className="p-2 text-center">Amount</th>
//                                             <th className="p-2 text-center">Refund ID</th>
//                                             <th className="p-2 text-center">Payment</th>
//                                             <th className="p-2 text-center">Description</th>
//                                             <th className="p-2 text-center">Status</th>
//                                             <th className="text-center p-2">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredData.length > 0 ? (
//                                             filteredData.map((item, index) => (
//                                                 <tr key={item.refundId}>
//                                                     <td style={tdStyle}>{item.sno || index + 1}</td>
//                                                     <td style={tdStyle}>{item.orderId}</td>
//                                                     <td style={tdStyle}>{item.userId}</td>
//                                                     <td style={tdStyle}>{item.transactionId}</td>
//                                                     <td style={tdStyle}>{item.userName}</td>
//                                                     <td style={tdStyle}>
//                                                         {new Date(item.cancelledAt).toLocaleDateString()}
//                                                     </td>
//                                                     <td style={tdStyle}>
//                                                         {new Date(item.cancelledAt).toLocaleTimeString()}
//                                                     </td>
//                                                     <td style={tdStyle}>₹{Number(item.price || 0).toFixed(2)}</td>
//                                                     <td style={tdStyle}>{item.refundId}</td>
//                                                     <td style={tdStyle}>{item.paymentMethod}</td>
//                                                     <td style={tdStyle}>Refund Requested</td>
//                                                     <td style={tdStyle}>{item.status}</td>
//                                                     <td className="p-3">
//                                                         <div className="d-flex flex-column gap-2">
//                                                             <button
//                                                                 className="btn btn-success btn-sm"
//                                                                 onClick={() => handleApprove(item.refundId)}
//                                                                 disabled={item.refundStatus === "REFUNDED"}
//                                                             >
//                                                                 {item.refundStatus === "REFUNDED" ? "Refunded" : "Approve"}
//                                                             </button>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                             ))
//                                         ) : (
//                                             <tr>
//                                                 <td colSpan="13" style={{ 
//                                                     fontStyle: "italic",
//                                                     textAlign: "center",
//                                                     padding: "20px",
//                                                     color: "#888"
//                                                 }}>
//                                                     {allData.length === 0
//                                                         ? "Loading data or no refunds found."
//                                                         : (searchQuery.trim() || selectedStatusFilter || filterDate)
//                                                             ? "No refunds found with the specified filters."
//                                                             : "No refunds match the current filters."}
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Details Modal */}
//             {selectedItem && (
//                 <div className="modal fade show bg-white" tabIndex={-1} style={{ display: "block" }}>
//                     <div className="modal-dialog modal-lg bg-white">
//                         <div className="modal-content bg-white border-0">
//                             <div className="modal-header">
//                                 <h5 className="modal-title">Cancellation/Refund Details</h5>
//                                 <button type="button" className="btn-close" onClick={closeDetailsModal}></button>
//                             </div>
//                             <div className="modal-body">
//                                 <p><strong>Order ID:</strong> {selectedItem.userId}</p>
//                                 <p><strong>Customer Name:</strong> {selectedItem.userName}</p>
//                                 <p><strong>Request Date:</strong> {selectedItem.requestDate}</p>
//                                 <p><strong>Request Time:</strong> {selectedItem.requestTime}</p>
//                                 <p><strong>Amount:</strong> ${selectedItem.amount?.toFixed(2)}</p>
//                                 <p><strong>Transaction ID:</strong> {selectedItem.transactionId}</p>
//                                 <p><strong>Payment Method:</strong> {selectedItem.paymentMethod}</p>
//                                 <p><strong>Proposed Resolution Date:</strong> {selectedItem.resolutionDate}</p>
//                                 <p className="mb-1"><strong>Reason for Cancellation/Refund:</strong></p>
//                                 <p className="p-2 bg-light border rounded" style={{ whiteSpace: "pre-line" }}>
//                                     {selectedItem.reason}
//                                 </p>
//                                 <p><strong>Current Status:</strong>
//                                     <span className={`ms-2 badge ${getStatusBadgeClass(selectedItem.status)}`}>
//                                         {selectedItem.status}
//                                     </span>
//                                 </p>
//                             </div>
//                             <div className="modal-footer">
//                                 <button className="btn btn-primary" onClick={closeDetailsModal}>Close</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Refund Popup */}
//             {isPopupOpen && selectedRefund && (
//                 <div style={{
//                     position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
//                     background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px"
//                 }}>
//                     <div style={{
//                         background: "#fff", padding: "30px", borderRadius: "12px", width: "100%", maxWidth: "500px",
//                         boxShadow: "0 8px 20px rgba(0,0,0,0.25)", fontFamily: "'Segoe UI', sans-serif"
//                     }}>
//                         <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
//                             <label>Refund ID:<input type="text" value={selectedRefund.refundId || ""} readOnly style={inputStyle} /></label>
//                             <label>Order ID:<input type="text" value={selectedRefund.orderId || ""} readOnly style={inputStyle} /></label>
//                             <label>User Name:<input type="text" value={selectedRefund.userName || ""} readOnly style={inputStyle} /></label>
//                             <label>Price:<input type="text" value={`₹${selectedRefund.price || "0.00"}`} readOnly style={inputStyle} /></label>
//                             <label>Cancelled At:<input type="text" value={selectedRefund.cancelledAt ? new Date(selectedRefund.cancelledAt).toLocaleString() : ""} readOnly style={inputStyle} /></label>
//                             <label>Transaction ID:<input type="text" value={selectedRefund.transactionId || ""} readOnly style={inputStyle} /></label>
//                             <label>Payment Method:<input type="text" value={selectedRefund.paymentMethod || ""} readOnly style={inputStyle} /></label>
//                         </div>
//                         <div style={{ textAlign: "center", marginTop: "25px" }}>
//                             <button onClick={closePopup} style={{ backgroundColor: "#d63031", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" }}>Close</button>
//                             <button onClick={handleSaveRefund} style={{ backgroundColor: "#00b894", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold", marginLeft: "10px" }}>Save</button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Cancelandrefundpage;























// import React, { useEffect, useState, useMemo } from "react";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import axios from "axios";

// const Cancelandrefundpage = () => {
//     const [allData, setAllData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const { showLoader, hideLoader } = useLoader();

//     // New filter states
//     const [searchType, setSearchType] = useState("userId"); // Default search type
//     const [searchQuery, setSearchQuery] = useState("");
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [filterDate, setFilterDate] = useState("");

//     // Search options for dropdown
//     const searchOptions = [
//         { value: "userId", label: "User ID" },
//         { value: "orderId", label: "Order ID" },
//         { value: "userName", label: "User Name" },
//         { value: "transactionId", label: "Transaction ID" },
//         { value: "refundId", label: "Refund ID" }
//     ];

//     const [selectedItem, setSelectedItem] = useState(null); // Details modal
//     const [isPopupOpen, setIsPopupOpen] = useState(false); // Refund popup
//     const [selectedRefund, setSelectedRefund] = useState(null);

//     // Fetch refund history from API
//     const fetchRefundHistory = async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             showLoader();
//             const token = localStorage.getItem("authToken");
//             if (!token) throw new Error("Authentication token not found. Please login again.");

//             const res = await axios.get(
//                 "https://backend.maamaas.com/food/api/refundhistory/all",
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             if (Array.isArray(res.data)) {
//                 // 🔥 Show only Online_Payment AND Maamaas_Wallet rows
//                 const filteredPayments = res.data.filter(
//                     item => item.paymentMethod === "Online_Payment" || item.paymentMethod === "Maamaas_Wallet"
//                 );

//                 // Add serial numbers
//                 const dataWithSno = filteredPayments.map((item, index) => ({
//                     ...item,
//                     sno: index + 1
//                 }));

//                 setAllData(dataWithSno);
//                 setFilteredData(dataWithSno);
//             } else {
//                 throw new Error("Unexpected response format");
//             }
//         } catch (err) {
//             console.error(err);
//             setError(err?.response?.data?.message || err.message || "Failed to fetch data.");
//         } finally {
//             setLoading(false);
//             hideLoader();
//         }
//     };

//     useEffect(() => {
//         fetchRefundHistory();
//     }, []);

//     // Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "userId": return "Search User ID";
//             case "orderId": return "Search Order ID";
//             case "userName": return "Search User Name";
//             case "transactionId": return "Search Transaction ID";
//             case "refundId": return "Search Refund ID";
//             default: return "Search...";
//         }
//     };

//     // Filter data based on selected search type, query, status, and date
//     const searchFilteredData = useMemo(() => {
//         if (!searchQuery.trim() && !selectedStatusFilter && !filterDate) {
//             return allData;
//         }

//         const query = searchQuery.toLowerCase().trim();

//         return allData.filter(item => {
//             // Search filter
//             let searchMatch = true;
//             if (searchQuery.trim()) {
//                 const fieldValue = item[searchType];
//                 searchMatch = fieldValue && 
//                     fieldValue.toString().toLowerCase().includes(query);
//             }

//             // Status filter
//             let statusMatch = true;
//             if (selectedStatusFilter) {
//                 statusMatch = item.status === selectedStatusFilter;
//             }

//             // Date filter
//             let dateMatch = true;
//             if (filterDate) {
//                 const itemDate = item.cancelledAt ? 
//                     formatDateForDisplay(item.cancelledAt) : "";
//                 dateMatch = itemDate === filterDate;
//             }

//             return searchMatch && statusMatch && dateMatch;
//         });
//     }, [allData, searchType, searchQuery, selectedStatusFilter, filterDate]);

//     // Update filteredData whenever searchFilteredData changes
//     useEffect(() => {
//         setFilteredData(searchFilteredData);
//     }, [searchFilteredData]);

//     // Clear all filters
//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setSelectedStatusFilter("");
//         setFilterDate("");
//     };

//     const updateItemStatus = (userId, newStatus) => {
//         setAllData((prevData) =>
//             prevData.map((item) => (item.userId === userId ? { ...item, status: newStatus } : item))
//         );
//     };

//     // Approve refund: fetch details and show popup
//     const handleApprove = async (refundId) => {
//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) throw new Error("Authentication token is missing.");

//             const res = await fetch(
//                 `https://backend.maamaas.com/food/api/refundhistory/get/order/${refundId}`,
//                 {
//                     method: "GET",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (!res.ok) throw new Error(`Failed to fetch refund details. Status: ${res.status}`);

//             const data = await res.json();
//             let refundDetails = null;
//             if (data?.refundId) refundDetails = data;
//             else if (Array.isArray(data) && data.length > 0) refundDetails = data[0];
//             else if (data?.data?.refundId) refundDetails = data.data;
//             else throw new Error("Refund details not found in response.");

//             setSelectedRefund(refundDetails);
//             setIsPopupOpen(true);
//         } catch (err) {
//             console.error(err);
//             alert("Could not fetch refund details.");
//         }
//     };

//     const closePopup = () => {
//         setIsPopupOpen(false);
//         setSelectedRefund(null);
//     };

//     const handleSaveRefund = async () => {
//         if (!selectedRefund || !selectedRefund.transactionId || !selectedRefund.price) {
//             alert("Missing transaction ID or amount.");
//             return;
//         }

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication token is missing.");
//             return;
//         }

//         try {
//             // Handle different payment methods
//             if (selectedRefund.paymentMethod === "Online_Payment") {
//                 // 1️⃣ CALL REFUND API FOR ONLINE PAYMENT
//                 const refundResponse = await fetch(
//                     "https://backend.maamaas.com/food/api/payments/refund",
//                     {
//                         method: "POST",
//                         headers: {
//                             "Content-Type": "application/json",
//                             Authorization: `Bearer ${token}`,
//                         },
//                         body: JSON.stringify({
//                             payment_id: selectedRefund.transactionId,
//                         }),
//                     }
//                 );

//                 const refundResult = await refundResponse.json();

//                 if (!refundResponse.ok) {
//                     alert("Refund failed: " + (refundResult?.message || "Unknown error"));
//                     return;
//                 }
//             } else if (selectedRefund.paymentMethod === "Maamaas_Wallet") {
//                 // Handle wallet refund logic here
//                 // You might need a different API endpoint for wallet refunds
//                 alert("Maamaas Wallet refund logic would be implemented here");
//             }

//             // 2️⃣ CALL UPDATE REFUND HISTORY API (same for both payment methods)
//             const updateResponse = await fetch(
//                 `https://backend.maamaas.com/food/api/refundhistory/update/${selectedRefund.refundId}/REFUNDED`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             const updateResult = await updateResponse.json();

//             if (!updateResponse.ok) {
//                 alert("Refund submitted but history update failed: " + (updateResult?.message || "Unknown error"));
//                 return;
//             }

//             alert("✅ Refund processed and history updated successfully!");
//             closePopup();

//         } catch (err) {
//             console.error(err);
//             alert("Something went wrong.");
//         }
//     };

//     const closeDetailsModal = () => setSelectedItem(null);

//     // Format date to display only date part in day/month/year format
//     const formatDateForDisplay = (dateString) => {
//         if (!dateString) return "-";
//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) return "-";

//             const day = String(date.getDate()).padStart(2, '0');
//             const month = String(date.getMonth() + 1).padStart(2, '0');
//             const year = date.getFullYear();

//             return `${day}/${month}/${year}`;
//         } catch (error) {
//             console.error("Error formatting date:", error);
//             return "-";
//         }
//     };

//     // Format date and time for display
//     const formatDateTimeForDisplay = (dateString) => {
//         if (!dateString) return "-";
//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) return "-";

//             const day = String(date.getDate()).padStart(2, '0');
//             const month = String(date.getMonth() + 1).padStart(2, '0');
//             const year = date.getFullYear();
//             const hours = String(date.getHours()).padStart(2, '0');
//             const minutes = String(date.getMinutes()).padStart(2, '0');
//             const seconds = String(date.getSeconds()).padStart(2, '0');

//             return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
//         } catch (error) {
//             console.error("Error formatting date/time:", error);
//             return "-";
//         }
//     };

//     // Format date for input field (YYYY-MM-DD)
//     const formatDateForInput = (dateString) => {
//         if (!dateString) return "";
//         try {
//             // If date is already in day/month/year format, convert it
//             if (dateString.includes('/')) {
//                 const parts = dateString.split('/');
//                 if (parts.length === 3) {
//                     const [day, month, year] = parts;
//                     return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//                 }
//             }

//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) return "";

//             const year = date.getFullYear();
//             const month = String(date.getMonth() + 1).padStart(2, '0');
//             const day = String(date.getDate()).padStart(2, '0');

//             return `${year}-${month}-${day}`;
//         } catch (error) {
//             console.error("Error formatting date for input:", error);
//             return "";
//         }
//     };

//     // Fixed export function to export filtered data
//     const handleExport = () => {
//         const exportData = filteredData.length > 0 ? filteredData : allData;

//         if (exportData.length === 0) {
//             alert("There is no data to export.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = [
//             "S.NO",
//             "Order ID",
//             "User ID",
//             "Name",
//             "Request Date",
//             "Request Time",
//             "Amount",
//             "Transaction ID",
//             "Refund ID",
//             "Payment Method",
//             "Status",
//             "Cancelled At"
//         ];

//         const csvRows = exportData.map((row) => [
//             row.sno || '',
//             row.orderId || '',
//             row.userId || '',
//             row.userName || '',
//             row.cancelledAt ? formatDateForDisplay(row.cancelledAt) : '',
//             row.cancelledAt ? formatTimeForDisplay(row.cancelledAt) : '',
//             `₹${Number(row.price || 0).toFixed(2)}`,
//             row.transactionId || '',
//             row.refundId || '',
//             row.paymentMethod || '',
//             row.status || '',
//             row.cancelledAt ? formatDateTimeForDisplay(row.cancelledAt) : ''
//         ]);

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", "cancellations_and_refunds.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     // Format time for display (HH:MM:SS)
//     const formatTimeForDisplay = (dateString) => {
//         if (!dateString) return "-";
//         try {
//             const date = new Date(dateString);
//             if (isNaN(date.getTime())) return "-";

//             const hours = String(date.getHours()).padStart(2, '0');
//             const minutes = String(date.getMinutes()).padStart(2, '0');
//             const seconds = String(date.getSeconds()).padStart(2, '0');

//             return `${hours}:${minutes}:${seconds}`;
//         } catch (error) {
//             console.error("Error formatting time:", error);
//             return "-";
//         }
//     };

//     const uniqueStatuses = useMemo(
//         () => [...new Set(allData.map((item) => item.status))].sort(),
//         [allData]
//     );

//     const getStatusBadgeClass = (status) => {
//         switch (status.toLowerCase()) {
//             case "pending":
//                 return "bg-warning text-dark";
//             case "approved":
//                 return "bg-success";
//             case "rejected":
//                 return "bg-danger";
//             default:
//                 return "bg-secondary";
//         }
//     };

//     const thStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         fontWeight: "bold",
//         backgroundColor: "rgb(230 109 51)",
//         color: "white",
//     };
//     const tdStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//     };
//     const inputStyle = {
//         width: "100%",
//         padding: "8px",
//         borderRadius: "6px",
//         border: "1px solid #ccc",
//         marginTop: "4px",
//         backgroundColor: "#f9f9f9",
//         fontSize: "15px",
//     };

//     return (
//         <div className="container-fluid d-flex flex-column">
//             {/* Filters & Export */}
//             <div className="row flex-grow-1" style={{ marginTop: "0px" }}>
//                 <div className="col-lg-12 col-12 ps-2 pe-2">
//                     <div className="vh-100" style={{ scrollbarWidth: "none", }}>
//                         {/* Filter Controls - Same as Userdetails */}
//                         <div className="row g-2 mb-1 align-items-center me-0">
//                             {/* Search Type Dropdown and Search Input - Side by Side */}
//                             <div className="col-md-auto col-12">
//                                 <div className="d-flex align-items-center" style={{ gap: '10px' }}>
//                                     {/* Search Type Dropdown */}
//                                     <div style={{ minWidth: '150px' }}>
//                                         <select
//                                             className="form-select"
//                                             value={searchType}
//                                             onChange={(e) => setSearchType(e.target.value)}
//                                             style={{ height: "40px" }}
//                                         >
//                                             {searchOptions.map(option => (
//                                                 <option key={option.value} value={option.value}>
//                                                     {option.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     {/* Search Input */}
//                                     <div style={{ minWidth: '200px' }}>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             placeholder={getPlaceholderText()}
//                                             value={searchQuery}
//                                             onChange={(e) => setSearchQuery(e.target.value)}
//                                             style={{ height: "40px" }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Status Filter */}
//                             <div className="col-md-auto col-12">
//                                 <select
//                                     className="form-select"
//                                     value={selectedStatusFilter}
//                                     onChange={(e) => setSelectedStatusFilter(e.target.value)}
//                                     aria-label="Filter by status"
//                                     style={{ maxWidth: '150px', height: "40px" }}
//                                 >
//                                     <option value="">All Status</option>
//                                     {uniqueStatuses.map(status => (
//                                         <option key={status} value={status}>{status}</option>
//                                     ))}
//                                 </select>
//                             </div>

//                             {/* Date Filter */}
//                             <div className="col-md-auto col-12">
//                                 <input
//                                     className="form-control"
//                                     type="date"
//                                     value={formatDateForInput(filterDate)}
//                                     onChange={(e) => setFilterDate(formatDateForDisplay(e.target.value))}
//                                     style={{ height: "40px", minWidth: '150px' }}
//                                 />
//                             </div>

//                             {/* Clear Filters Button */}
//                             <div className="col-md-auto col-12">
//                                 <button
//                                     className="btn"
//                                     onClick={clearAllFilters}
//                                     style={{
//                                         backgroundColor: '#6c757d',
//                                         color: '#fff',
//                                         height: "40px",
//                                         padding: "0 15px"
//                                     }}
//                                 >
//                                     Clear Filters
//                                 </button>
//                             </div>

//                             {/* Export Button */}
//                             <div className="col-md col-12">
//                                 <div className="d-flex justify-content-start justify-content-md-end">
//                                     <button
//                                         onClick={handleExport}
//                                         className="btn"
//                                         style={{ 
//                                             backgroundColor: 'rgb(230 109 51)', 
//                                             color: '#fff',
//                                             height: "40px",
//                                             padding: "0 20px",
//                                             fontWeight: "bold",
//                                         }}
//                                     >
//                                         Export CSV
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Table */}
//                         {loading && <p className="text-center mt-5">Loading data...</p>}
//                         {error && <p className="text-center text-danger mt-5">{error}</p>}
//                         {!loading && !error && (
//                             <div
//                                 className="table-responsive shadow-sm roror3"
//                                 style={{ height: "calc(100vh - 255px)", overflowY: "auto", scrollbarWidth: "none", marginTop: "10px" }}
//                             >
//                                 <table className="table-striped table-bordered table-hover align-middle">
//                                     <thead style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}>
//                                         <tr>
//                                             <th className="p-2 text-center">SNO</th>
//                                             <th className="p-2 text-center">Order ID</th>
//                                             <th className="p-2 text-center">User ID</th>
//                                             <th className="p-2 text-center">Transaction Id</th>
//                                             <th className="p-2 text-center">Name</th>
//                                             <th className="p-2 text-center">Request Date</th>
//                                             <th className="p-2 text-center">Request Time</th>
//                                             <th className="p-2 text-center">Amount</th>
//                                             <th className="p-2 text-center">Refund ID</th>
//                                             <th className="p-2 text-center">Payment</th>
//                                             <th className="p-2 text-center">Description</th>
//                                             <th className="p-2 text-center">Status</th>
//                                             <th className="text-center p-2">Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {filteredData.length > 0 ? (
//                                             filteredData.map((item, index) => (
//                                                 <tr key={item.refundId}>
//                                                     <td style={tdStyle}>{item.sno || index + 1}</td>
//                                                     <td style={tdStyle}>{item.orderId}</td>
//                                                     <td style={tdStyle}>{item.userId}</td>
//                                                     <td style={tdStyle}>{item.transactionId}</td>
//                                                     <td style={tdStyle}>{item.userName}</td>
//                                                     <td style={tdStyle}>
//                                                         {formatDateForDisplay(item.cancelledAt)}
//                                                     </td>
//                                                     <td style={tdStyle}>
//                                                         {formatTimeForDisplay(item.cancelledAt)}
//                                                     </td>
//                                                     <td style={tdStyle}>₹{Number(item.price || 0).toFixed(2)}</td>
//                                                     <td style={tdStyle}>{item.refundId}</td>
//                                                     <td style={tdStyle}>{item.paymentMethod}</td>
//                                                     <td style={tdStyle}>Refund Requested</td>
//                                                     <td style={tdStyle}>{item.status}</td>
//                                                     <td className="p-3">
//                                                         <div className="d-flex flex-column gap-2">
//                                                             <button
//                                                                 className="btn btn-success btn-sm"
//                                                                 onClick={() => handleApprove(item.refundId)}
//                                                                 disabled={item.refundStatus === "REFUNDED"}
//                                                             >
//                                                                 {item.refundStatus === "REFUNDED" ? "Refunded" : "Approve"}
//                                                             </button>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                             ))
//                                         ) : (
//                                             <tr>
//                                                 <td colSpan="13" style={{ 
//                                                     fontStyle: "italic",
//                                                     textAlign: "center",
//                                                     padding: "20px",
//                                                     color: "#888"
//                                                 }}>
//                                                     {allData.length === 0
//                                                         ? "Loading data or no refunds found."
//                                                         : (searchQuery.trim() || selectedStatusFilter || filterDate)
//                                                             ? "No refunds found with the specified filters."
//                                                             : "No refunds match the current filters."}
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Details Modal */}
//             {selectedItem && (
//                 <div className="modal fade show bg-white" tabIndex={-1} style={{ display: "block" }}>
//                     <div className="modal-dialog modal-lg bg-white">
//                         <div className="modal-content bg-white border-0">
//                             <div className="modal-header">
//                                 <h5 className="modal-title">Cancellation/Refund Details</h5>
//                                 <button type="button" className="btn-close" onClick={closeDetailsModal}></button>
//                             </div>
//                             <div className="modal-body">
//                                 <p><strong>Order ID:</strong> {selectedItem.userId}</p>
//                                 <p><strong>Customer Name:</strong> {selectedItem.userName}</p>
//                                 <p><strong>Request Date:</strong> {selectedItem.requestDate}</p>
//                                 <p><strong>Request Time:</strong> {selectedItem.requestTime}</p>
//                                 <p><strong>Amount:</strong> ${selectedItem.amount?.toFixed(2)}</p>
//                                 <p><strong>Transaction ID:</strong> {selectedItem.transactionId}</p>
//                                 <p><strong>Payment Method:</strong> {selectedItem.paymentMethod}</p>
//                                 <p><strong>Proposed Resolution Date:</strong> {selectedItem.resolutionDate}</p>
//                                 <p className="mb-1"><strong>Reason for Cancellation/Refund:</strong></p>
//                                 <p className="p-2 bg-light border rounded" style={{ whiteSpace: "pre-line" }}>
//                                     {selectedItem.reason}
//                                 </p>
//                                 <p><strong>Current Status:</strong>
//                                     <span className={`ms-2 badge ${getStatusBadgeClass(selectedItem.status)}`}>
//                                         {selectedItem.status}
//                                     </span>
//                                 </p>
//                             </div>
//                             <div className="modal-footer">
//                                 <button className="btn btn-primary" onClick={closeDetailsModal}>Close</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Refund Popup */}
//                        {/* Refund Popup */}
//             {isPopupOpen && selectedRefund && (
//                 <div style={{
//                     position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
//                     background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px"
//                 }}>
//                     <div style={{
//                         background: "#fff", 
//                         padding: "20px", 
//                         borderRadius: "12px", 
//                         width: "100%", 
//                         maxWidth: "500px",
//                         maxHeight: "90vh", // Added max height
//                         overflowY: "auto", // Added scroll for vertical overflow
//                         boxShadow: "0 8px 20px rgba(0,0,0,0.25)", 
//                         fontFamily: "'Segoe UI', sans-serif",
//                         display: "flex",
//                         flexDirection: "column"
//                     }}>
//                         <div style={{ 
//                             display: "flex", 
//                             flexDirection: "column", 
//                             gap: "15px",
//                             flex: 1,
//                             overflowY: "auto", // Added scroll for content area
//                             paddingRight: "5px", // Space for scrollbar
//                             marginBottom: "20px"
//                         }}>
//                             <div>
//                                 <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>Refund ID:</label>
//                                 <input type="text" value={selectedRefund.refundId || ""} readOnly style={inputStyle} />
//                             </div>
//                             <div>
//                                 <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>Order ID:</label>
//                                 <input type="text" value={selectedRefund.orderId || ""} readOnly style={inputStyle} />
//                             </div>
//                             <div>
//                                 <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>User Name:</label>
//                                 <input type="text" value={selectedRefund.userName || ""} readOnly style={inputStyle} />
//                             </div>
//                             <div>
//                                 <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>Price:</label>
//                                 <input type="text" value={`₹${selectedRefund.price || "0.00"}`} readOnly style={inputStyle} />
//                             </div>
//                             <div>
//                                 <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>Cancelled At:</label>
//                                 <input type="text" value={selectedRefund.cancelledAt ? formatDateTimeForDisplay(selectedRefund.cancelledAt) : ""} readOnly style={inputStyle} />
//                             </div>
//                             <div>
//                                 <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>Transaction ID:</label>
//                                 <input type="text" value={selectedRefund.transactionId || ""} readOnly style={inputStyle} />
//                             </div>
//                             <div>
//                                 <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>Payment Method:</label>
//                                 <input type="text" value={selectedRefund.paymentMethod || ""} readOnly style={inputStyle} />
//                             </div>
//                         </div>
//                         <div style={{ 
//                             textAlign: "center", 
//                             marginTop: "auto", 
//                             paddingTop: "20px",
//                             borderTop: "1px solid #eee"
//                         }}>
//                             <button onClick={closePopup} style={{ 
//                                 backgroundColor: "#d63031", 
//                                 color: "#fff", 
//                                 border: "none", 
//                                 padding: "10px 20px", 
//                                 borderRadius: "6px", 
//                                 cursor: "pointer", 
//                                 fontWeight: "bold",
//                                 marginRight: "10px"
//                             }}>Close</button>
//                             <button onClick={handleSaveRefund} style={{ 
//                                 backgroundColor: "#00b894", 
//                                 color: "#fff", 
//                                 border: "none", 
//                                 padding: "10px 20px", 
//                                 borderRadius: "6px", 
//                                 cursor: "pointer", 
//                                 fontWeight: "bold"
//                             }}>Save</button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Cancelandrefundpage;




















import React, { useEffect, useState, useMemo } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    refundApi,
    refundDataProcessor,
    refundDateFormatter,
    refundExport,
    refundUIConstants
} from '../../../Servicefile/Apiservice.js';

const Cancelandrefundpage = () => {
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { showLoader, hideLoader } = useLoader();

    // Filter states
    const [searchType, setSearchType] = useState("userId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [filterDate, setFilterDate] = useState("");

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedRefund, setSelectedRefund] = useState(null);

    // Fetch refund history
    const fetchRefundHistory = async () => {
        setLoading(true);
        setError(null);
        try {
            showLoader();
            const data = await refundApi.getAllRefundHistory();

            if (Array.isArray(data)) {
                const filteredPayments = refundDataProcessor.filterPaymentMethods(data);
                const dataWithSno = refundDataProcessor.addSerialNumbers(filteredPayments);
                setAllData(dataWithSno);
                setFilteredData(dataWithSno);
            } else {
                throw new Error("Unexpected response format");
            }
        } catch (err) {
            setError(err?.response?.data?.message || err.message || "Failed to fetch data.");
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    useEffect(() => {
        fetchRefundHistory();
    }, []);

    // Apply filters
    const searchFilteredData = useMemo(() => {
        return refundDataProcessor.filterData(
            allData, searchType, searchQuery, selectedStatusFilter, filterDate
        );
    }, [allData, searchType, searchQuery, selectedStatusFilter, filterDate]);

    useEffect(() => {
        setFilteredData(searchFilteredData);
    }, [searchFilteredData]);

    const uniqueStatuses = useMemo(
        () => refundDataProcessor.getUniqueStatuses(allData),
        [allData]
    );

    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedStatusFilter("");
        setFilterDate("");
    };

    const handleApprove = async (refundId) => {
        try {
            const data = await refundApi.getRefundByOrderId(refundId);

            const refundDetails = data?.refundId ? data :
                (Array.isArray(data) && data[0]) ||
                data?.data || null;

            if (!refundDetails) throw new Error("Refund details not found.");

            setSelectedRefund(refundDetails);
            setIsPopupOpen(true);
        } catch (err) {
            console.error(err);
            alert("Could not fetch refund details.");
        }
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setSelectedRefund(null);
    };

    const handleSaveRefund = async () => {
        if (!selectedRefund?.transactionId || !selectedRefund?.price) {
            alert("Missing transaction ID or amount.");
            return;
        }

        try {
            if (selectedRefund.paymentMethod === "Online_Payment") {
                await refundApi.processOnlineRefund(selectedRefund.transactionId);
            } else if (selectedRefund.paymentMethod === "Maamaas_Wallet") {
                alert("Maamaas Wallet refund logic would be implemented here");
            }

            await refundApi.updateRefundStatus(selectedRefund.refundId, "REFUNDED");

            alert("✅ Refund processed successfully!");
            closePopup();
            fetchRefundHistory();
        } catch (err) {
            console.error(err);
            alert("Something went wrong.");
        }
    };

    const handleExport = () => {
        const exportData = filteredData.length > 0 ? filteredData : allData;
        refundExport.exportToCSV(exportData);
    };

    return (
        <div className="container-fluid d-flex flex-column">
            {/* Filters & Export */}
            <div className="row flex-grow-1" style={{ marginTop: "10px" }}>
                <div className="col-lg-12 col-12 ps-2 pe-2">
                    <div className="vh-100" style={{ scrollbarWidth: "none" }}>
                        {/* Filter Controls */}
                        <div className="row g-2 mb-1 align-items-center me-0">
                            <div className="col-md-auto col-12">
                                <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                    <div style={{ minWidth: '150px' }}>
                                        <select
                                            className="form-select"
                                            value={searchType}
                                            onChange={(e) => setSearchType(e.target.value)}
                                            style={{ height: "40px" }}
                                        >
                                            {refundUIConstants.searchOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div style={{ minWidth: '200px' }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={refundUIConstants.getPlaceholderText(searchType)}
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            style={{ height: "40px" }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-auto col-12">
                                <select
                                    className="form-select"
                                    value={selectedStatusFilter}
                                    onChange={(e) => setSelectedStatusFilter(e.target.value)}
                                    style={{ maxWidth: '150px', height: "40px" }}
                                >
                                    <option value="">All Status</option>
                                    {uniqueStatuses.map(status => (
                                        <option key={status} value={status}>{status}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-auto col-12">
                                <input
                                    className="form-control"
                                    type="date"
                                    value={refundDateFormatter.formatDateForInput(filterDate)}
                                    onChange={(e) => setFilterDate(refundDateFormatter.formatDateForDisplay(e.target.value))}
                                    style={{ height: "40px", minWidth: '150px' }}
                                />
                            </div>

                            <div className="col-md-auto col-12">
                                <button
                                    className="btn"
                                    onClick={clearAllFilters}
                                    style={{
                                        backgroundColor: '#6c757d',
                                        color: '#fff',
                                        height: "40px",
                                        padding: "0 15px"
                                    }}
                                >
                                    Clear Filters
                                </button>
                            </div>

                            <div className="col-md col-12">
                                <div className="d-flex justify-content-end">
                                    <button
                                        onClick={handleExport}
                                        className="btn"
                                        style={{
                                            backgroundColor: 'rgb(230 109 51)',
                                            color: '#fff',
                                            height: "40px",
                                            padding: "0 20px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Export CSV
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        {loading && <p className="text-center mt-5">Loading data...</p>}
                        {error && <p className="text-center text-danger mt-5">{error}</p>}
                        {!loading && !error && (
                            <div
                                className="table-responsive shadow-sm"
                                style={{ height: "60vh", overflowY: "auto", marginTop: "10px" }}
                            >
                                <table className="table-striped table-bordered table-hover align-middle">
                                    <thead style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}>
                                        <tr>
                                            <th className="p-2 text-center">SNO</th>
                                            <th className="p-2 text-center">Order ID</th>
                                            <th className="p-2 text-center">User ID</th>
                                            <th className="p-2 text-center">Transaction Id</th>
                                            <th className="p-2 text-center">Name</th>
                                            <th className="p-2 text-center">Request Date</th>
                                            <th className="p-2 text-center">Request Time</th>
                                            <th className="p-2 text-center">Amount</th>
                                            <th className="p-2 text-center">Refund ID</th>
                                            <th className="p-2 text-center">Payment</th>
                                            <th className="p-2 text-center">Description</th>
                                            <th className="p-2 text-center">Status</th>
                                            <th className="text-center p-2">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((item, index) => (
                                                <tr key={item.refundId}>
                                                    <td style={refundUIConstants.tableStyles.td}>{item.sno || index + 1}</td>
                                                    <td style={refundUIConstants.tableStyles.td}>{item.orderId}</td>
                                                    <td style={refundUIConstants.tableStyles.td}>{item.userId}</td>
                                                    <td style={refundUIConstants.tableStyles.td}>{item.transactionId}</td>
                                                    <td style={refundUIConstants.tableStyles.td}>{item.userName}</td>
                                                    <td style={refundUIConstants.tableStyles.td}>
                                                        {refundDateFormatter.formatDateForDisplay(item.cancelledAt)}
                                                    </td>
                                                    <td style={refundUIConstants.tableStyles.td}>
                                                        {refundDateFormatter.formatTimeForDisplay(item.cancelledAt)}
                                                    </td>
                                                    <td style={refundUIConstants.tableStyles.td}>₹{Number(item.price || 0).toFixed(2)}</td>
                                                    <td style={refundUIConstants.tableStyles.td}>{item.refundId}</td>
                                                    <td style={refundUIConstants.tableStyles.td}>{item.paymentMethod}</td>
                                                    <td style={refundUIConstants.tableStyles.td}>Refund Requested</td>
                                                    <td style={refundUIConstants.tableStyles.td}>{item.status}</td>
                                                    <td className="p-3">
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() => handleApprove(item.refundId)}
                                                            disabled={item.refundStatus === "REFUNDED"}
                                                        >
                                                            {item.refundStatus === "REFUNDED" ? "Refunded" : "Approve"}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="13" style={{
                                                    fontStyle: "italic",
                                                    textAlign: "center",
                                                    padding: "20px",
                                                    color: "#888"
                                                }}>
                                                    {allData.length === 0
                                                        ? "Loading data or no refunds found."
                                                        : "No refunds found with the specified filters."}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Refund Popup */}
            {isPopupOpen && selectedRefund && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                    background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center",
                    justifyContent: "center", zIndex: 9999, padding: "20px"
                }}>
                    <div style={{
                        background: "#fff", padding: "20px", borderRadius: "12px",
                        width: "100%", maxWidth: "500px", maxHeight: "90vh", overflowY: "auto",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.25)"
                    }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <div>
                                <label style={{ fontWeight: "500" }}>Refund ID:</label>
                                <input type="text" value={selectedRefund.refundId || ""} readOnly style={refundUIConstants.tableStyles.input} />
                            </div>
                            <div>
                                <label style={{ fontWeight: "500" }}>Order ID:</label>
                                <input type="text" value={selectedRefund.orderId || ""} readOnly style={refundUIConstants.tableStyles.input} />
                            </div>
                            <div>
                                <label style={{ fontWeight: "500" }}>User Name:</label>
                                <input type="text" value={selectedRefund.userName || ""} readOnly style={refundUIConstants.tableStyles.input} />
                            </div>
                            <div>
                                <label style={{ fontWeight: "500" }}>Price:</label>
                                <input type="text" value={`₹${selectedRefund.price || "0.00"}`} readOnly style={refundUIConstants.tableStyles.input} />
                            </div>
                            <div>
                                <label style={{ fontWeight: "500" }}>Cancelled At:</label>
                                <input type="text" value={refundDateFormatter.formatDateTimeForDisplay(selectedRefund.cancelledAt)} readOnly style={refundUIConstants.tableStyles.input} />
                            </div>
                            <div>
                                <label style={{ fontWeight: "500" }}>Transaction ID:</label>
                                <input type="text" value={selectedRefund.transactionId || ""} readOnly style={refundUIConstants.tableStyles.input} />
                            </div>
                            <div>
                                <label style={{ fontWeight: "500" }}>Payment Method:</label>
                                <input type="text" value={selectedRefund.paymentMethod || ""} readOnly style={refundUIConstants.tableStyles.input} />
                            </div>
                        </div>
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <button onClick={closePopup} style={{
                                backgroundColor: "#d63031", color: "#fff", border: "none",
                                padding: "10px 20px", borderRadius: "6px", cursor: "pointer",
                                fontWeight: "bold", marginRight: "10px"
                            }}>Close</button>
                            <button onClick={handleSaveRefund} style={{
                                backgroundColor: "#00b894", color: "#fff", border: "none",
                                padding: "10px 20px", borderRadius: "6px", cursor: "pointer",
                                fontWeight: "bold"
                            }}>Save</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Cancelandrefundpage;